/**
 * Nsection A Service
 * A.摘要與適用性 API 服務
 */

import axios from '../api/axios';

const BASE_URL = '/api/nsection-a';

export interface NsectionADetail {
  id: number;
  organization_id: number;
  proposal_id: number;
  formal_title: string | null;
  submission_date: string | null;
  version_number: string | null;
  previous_reference: string | null;
  summary_description: string | null;
  nmeth_a_pct: number;
  edit_by: number;
  created_at: string;
  updated_at: string | null;
}

export interface NsectionAUpdate {
  formal_title?: string;
  submission_date?: string;
  version_number?: string;
  previous_reference?: string;
  summary_description?: string;
}

const nsectionAService = {
  getByProposal: async (proposalId: number): Promise<NsectionADetail | null> => {
    const response = await axios.get(`${BASE_URL}/by-proposal/${proposalId}`);
    return response.data;
  },

  update: async (proposalId: number, data: NsectionAUpdate): Promise<NsectionADetail> => {
    const response = await axios.put(`${BASE_URL}/${proposalId}`, data);
    return response.data;
  },
};

export default nsectionAService;
